module.exports = __webpack_public_path__ + "logo.png?dddf27d31a74e57c5491c000cc7bf9f0";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logo.png
// module id = 142
// module chunks = 0